import * as React from 'react';
import { useStaticQuery } from 'gatsby';
import { ShowMenuItems } from './navbar';
import FacebookIcon from "@fortawesome/fontawesome-free/svgs/brands/facebook-square.svg";
import TwitterIcon from "@fortawesome/fontawesome-free/svgs/brands/twitter-square.svg";
import InstagramIcon from "@fortawesome/fontawesome-free/svgs/brands/instagram-square.svg";
import EmailIcon from "@fortawesome/fontawesome-free/svgs/solid/envelope-square.svg";
export var Footer = function Footer() {
  var _ref = useStaticQuery("4058745906"),
      footer = _ref.site.siteMetadata.footer;

  return /*#__PURE__*/React.createElement("footer", {
    className: "footer " + footer.className
  }, /*#__PURE__*/React.createElement("div", {
    className: "container"
  }, /*#__PURE__*/React.createElement("div", {
    className: "logo"
  }, footer.logo.file && /*#__PURE__*/React.createElement("img", {
    src: footer.logo.file,
    alt: footer.logo.alt,
    style: {
      width: footer.logo.width
    }
  })), /*#__PURE__*/React.createElement("div", {
    className: "columns",
    style: {
      marginLeft: 0,
      marginRight: 0
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "column is-4 menu"
  }, /*#__PURE__*/React.createElement("ul", {
    className: "menu-list"
  }, /*#__PURE__*/React.createElement(ShowMenuItems, {
    items: footer.firstColumnItems,
    asListItem: true
  }))), /*#__PURE__*/React.createElement("div", {
    className: "column is-4 menu"
  }, /*#__PURE__*/React.createElement("ul", {
    className: "menu-list"
  }, /*#__PURE__*/React.createElement(ShowMenuItems, {
    items: footer.secondColumnItems,
    asListItem: true
  }))), /*#__PURE__*/React.createElement("div", {
    className: "column is-4 social"
  }, footer.social.facebook && /*#__PURE__*/React.createElement("a", {
    title: "Follow us on Facebook",
    href: footer.social.facebook,
    target: "_blank"
  }, /*#__PURE__*/React.createElement(FacebookIcon, null)), footer.social.twitter && /*#__PURE__*/React.createElement("a", {
    title: "Follow us on Twitter",
    href: footer.social.twitter,
    target: "_blank"
  }, /*#__PURE__*/React.createElement(TwitterIcon, null)), footer.social.instagram && /*#__PURE__*/React.createElement("a", {
    title: "Follow us on Instagram",
    href: footer.social.instagram,
    target: "_blank"
  }, /*#__PURE__*/React.createElement(InstagramIcon, null)), footer.social.email && /*#__PURE__*/React.createElement("a", {
    title: "Contact us",
    href: footer.social.email
  }, /*#__PURE__*/React.createElement(EmailIcon, null)))), /*#__PURE__*/React.createElement("div", {
    className: "made-with-love"
  }, footer.madeWithLove && /*#__PURE__*/React.createElement("small", null, footer.madeWithLove))));
};